//#region Imports Packages and Libs

import { STORE_MUTATION } from "../enums/store_mutation";
import { StateOption } from "../types/state_option";
import { IMessage } from "../interfaces/message";
import { __vueEvent, _convId } from "../constant";
import { EVENTS } from "../enums/events";
import {
    MESSAGE_COMPONENT_TYPE,
    MESSAGE_LAYOUT,
    MESSAGE_STRUCTURE_TYPE,
    MESSAGE_TYPE,
	TypeMessageLayout,
	TypeStructure
} from "../enums";
import { StorageHelper, appendMessage, getAddMessageAnchorScroll, getUniqId, isMessageStreaming } from "../helpers";
import { removeButtonsFromPayload } from "../helpers/remove_buttons_from_payload";
import { validateAndModify } from "../helpers/validate_and_modify";
import { MessageOptions } from "../types";
import { getTimeStamp } from "../helpers";
import { IFormInput } from "../interfaces/form_input";
import { IPageConfig } from '../interfaces/page_config';
import { Util } from '../util';
import { PropsComponent, PropsLayoutCarousel } from "../props";
import { feedbackMutations } from "./store-mutations";
import { getQueryStringValue } from "../helpers/get_querystring_value";

//#endregion

//#region Main Webchat Mutations

export const mutations = {
    [STORE_MUTATION.AddMessage]: (state: StateOption, value: IMessage, isWelcome: boolean = false) => {
        try {
            const addMessageAnchorScroll = getAddMessageAnchorScroll(state, value);
            const isStreaming = isMessageStreaming(state, value);
            let shouldSkipDefaultScroll = addMessageAnchorScroll.isTopAnchorScrollPosition || isStreaming;
            
            if(!state.isStreamingPages) {
                state.isStreamingPages = isStreaming;
            }
            
            if(shouldSkipDefaultScroll && addMessageAnchorScroll.incomingScrollPosition != "no_scroll") {
                state.lastScrollPosition = addMessageAnchorScroll.incomingScrollPosition;
            }

            state.incomingScrollPosition = addMessageAnchorScroll.incomingScrollPosition;
            
            state.shouldSkipDefaultScroll = shouldSkipDefaultScroll;
            
            
            if (state.messages.length > 1 && !shouldSkipDefaultScroll) {
                state.suppressNextScroll = false; // Reset scroll suppression flag for new messages
                __vueEvent.emit(EVENTS.ScrollChatToBottom, false);
            }
            __vueEvent.emit(EVENTS.RemoveAllButtons);

						// SD-8114: Assign a stable UUID for Vue list rendering only.
						// Ensures Vue will append DOM, instead of re-creating existing nodes.
            value.__vueKey = getUniqId();

            console.log("1");
            value = validateAndModify(value);
            console.log("Value:" + JSON.stringify(value));

            if (isWelcome) {
                state.messages = [value];
            }
            else {
                const isSkipWelcomeMessage = StorageHelper.get("skip_welcome_message"+ state.convId);
                      
                // Check if maintain state is on
                if (!state.maintainState || 
                    (state.skipWelcomeMessageOnURLInput && getQueryStringValue("input").length > 0) || 
                    (isSkipWelcomeMessage && isSkipWelcomeMessage == "1")) {
					appendMessage(state, value)
                } else {

                    /**
                     * Maintain state ON logic, as discussed on skype
                     *   1. Fresh Page show welcome message
                     *   2. If some chat which is less then 25 no of chat then show welcome message
                     *   3. if chat is more then 25 then no need to show welcome message
                     */

                    // Check if it is a welcome message,
                    // if true add the welcome message at the top of the array
                    let isWelcomeMessage = false;
                    let messageCacheId = "";
                    if (value && value.contents && value.contents.recordInfo && value.contents.recordInfo.messageCacheId
                        && value.contents.recordInfo.messageCacheId === "1") {
                        isWelcomeMessage = true;
                        messageCacheId = "1";
                    }

                    // Check if the welcome message is already in the store
                    const isMessageAlreadyInStore = state.messages.some(m => m.id === messageCacheId);
                    if (isWelcomeMessage) {
                        if (!isMessageAlreadyInStore) {
                            // Add the welcome message to the top of the chat screen
                            state.messages.unshift(value);
                        }
                        // SD-6823: Mark welcome as processed and flush any queued maintain-state messages
                        state.isWelcomeMessageProcessed = true;
                        if (Array.isArray(state.maintainStateQueue) && state.maintainStateQueue.length > 0) {
                            const queued = [...state.maintainStateQueue];
                            state.maintainStateQueue = [];
                            queued.forEach((msg) => {
                                appendMessage(state, msg);
                            });
                        }
                    } else {
                        // Check if we have a message from maintain state
                        // meaning from the `fetchMaintainStateMessages` api call
                        // SD-6823: If maintain-state messages arrive before welcome is processed, enqueue them
                        if (state.isMaintainStateMessages && !state.isWelcomeMessageProcessed) {
                            if (!Array.isArray(state.maintainStateQueue)) state.maintainStateQueue = [];
                            state.maintainStateQueue.push(value);
                        } else {
                            /* SD-7154: In the maintainState configuration the message showing in modal are not included in the chat container excluding it from the actual list */
                            appendMessage(state, value)
                        }
                    }
                }
            }

            console.log("Pushed");
            if (value && value.contents && value.contents.settings && value.contents.settings.clearScreen) {
                __vueEvent.emit(EVENTS.ScrollChatToTop);
            } else if (addMessageAnchorScroll.shouldScrollFirstAgentToAnchor) {
                __vueEvent.emit(EVENTS.ScrollFirstAgentToAnchor, {
                    scrollPosition: addMessageAnchorScroll.incomingScrollPosition,
                });
            } else if (state.messages.length > 1 && !shouldSkipDefaultScroll) {
                console.log("scroll to New Message Top");
                __vueEvent.emit(EVENTS.ScrollToNewMessageTop);
            }
            console.log("New Message");
            __vueEvent.emit(EVENTS.NewMessage, value);

            // Check if the new message is a modal response
            if (value && value.contents && value.contents.structures && value.contents.structures.length > 0
                && value.contents.structures[0].type === MESSAGE_STRUCTURE_TYPE.Modal) {

                // Find the new message in the state
                const msg = state.messages.find(message => message.id === value.id);
                if (msg != null && msg.contents && msg.contents.structures && msg.contents.structures.length > 0) {
                    const structure = msg.contents.structures[0];
                    //structure.showModal = structure.settings.autoOpen;
                    structure.showModal = true;
                }
            }
            
            if(isStreaming){
                __vueEvent.emit(EVENTS.SetScrollSpacerHeight);
            }

        } catch (ex) {
            console.log("invalid message", value.contents);
        }
    },
    [STORE_MUTATION.EnqueueMaintainStateMessage]: (state: StateOption, value: IMessage) => {
        if (!Array.isArray(state.maintainStateQueue)) state.maintainStateQueue = [];
        state.maintainStateQueue.push(value);
    },
    [STORE_MUTATION.FlushMaintainStateQueue]: (state: StateOption) => {
        if (!Array.isArray(state.maintainStateQueue) || state.maintainStateQueue.length === 0) return;
        const queued = [...state.maintainStateQueue];
        state.maintainStateQueue = [];
        queued.forEach((msg) => appendMessage(state, msg));
    },
    [STORE_MUTATION.ClearMaintainStateQueue]: (state: StateOption) => {
        state.maintainStateQueue = [];
    },
    [STORE_MUTATION.UpdateMessageStatus]: (
        state: StateOption,
        value: IMessage
    ) => {
        const msg = state.messages.find(message => message.id === value.id);
        if (msg != null) {
            msg.status = value.status;
        }
    },
    [STORE_MUTATION.UpdateMessageCacheID]: (
        state: StateOption,
        value: IMessage
    ) => {
        const msg = state.messages.find(message => message.id === value.id);
        if (msg != null) {
            msg.id = value.newId;
        }
    },
    [STORE_MUTATION.UpdateMessageStructure]: (
        state: StateOption,
        value: IMessage
    ) => {
        const msg = state.messages.find(message => message.id === value.id);
        if (msg != null) {
            msg.buttonMessageStructure = value.buttonMessageStructure;
        }
    },
    [STORE_MUTATION.SetIsShowHeaderInIframe]: (state: StateOption, value: boolean) => {
        state.isShowHeaderInIframe = value;
    },
    [STORE_MUTATION.SetIsHideTitleBar]: (state: StateOption, value: boolean) => {
        state.isHideTitleBar = value;
    },
    [STORE_MUTATION.SetUserId]: (state: StateOption, value: string) => {
        state.userId = value;
    },
    [STORE_MUTATION.SetUserIdSourceTypeId]: (state: StateOption, value: number) => {
        state.userIdSourceTypeId = value;
    },
    [STORE_MUTATION.SetIsBrowseUrlOnSametab]: (state: StateOption, value: boolean) => {
        state.isBrowseUrlOnSametab = value;
    },
    [STORE_MUTATION.SetIsAnchorTagClickedSametabNewtab]: (state: StateOption, value: boolean) => {
        state.isAnchorTagClickedSametabNewtab = value;
    },
    [STORE_MUTATION.SetIsConfigLoaded]: (state: StateOption, value: boolean) => {
        state.isConfigurationLoaded = value;
    },
    // [STORE_MUTATION.SetIsWelcomeMessage]: (state: StateOption, value: boolean) => {
    //     state.isWelcomeMessageLoaded = value;
    // },
    [STORE_MUTATION.SetBotId]: (state: StateOption, value: string) => {
        state.extBotId = Number(value);
    },
    [STORE_MUTATION.SetCompanyId]: (state: StateOption, value: string) => {
        state.companyId = Number(value);
    },
    [STORE_MUTATION.SetCompanyToken]: (state: StateOption, value: string) => {
        state.companyToken = value;
    },
    [STORE_MUTATION.SetSendMsgUrl]: (state: StateOption, value: string) => {
        state.sendMsgUrl = value;
    },
    [STORE_MUTATION.SetMaintainState]: (state: StateOption, value: boolean) => {
        state.maintainState = value;
    },
    [STORE_MUTATION.SetMessages]: (state: StateOption, value: IMessage[]) => {
        state.messages = value;
    },
    [STORE_MUTATION.SetShowInfoPanel]: (state: StateOption, value: boolean) => {
        state.showInfoPanel = value;
    },
    [STORE_MUTATION.SetDisableInput]: (state: StateOption, value: boolean) => {
        state.disableInput = value;
    },
    [STORE_MUTATION.SetDefaulthideInputContainerSetting]: (state: StateOption, value: boolean) => {
        state.defaulthideInputContainerSetting = value;
    },
    [STORE_MUTATION.SetErrorMessage]: (state: StateOption, value: string) => {
        state.errorMessage = value;
    },
    [STORE_MUTATION.SetTypingMessageSecondsInterval]: (state: StateOption, value: number) => {
        state.typingMessageSecondsInterval = value;
    },
    [STORE_MUTATION.SetRetryWarningCount]: (
        state: StateOption,
        value: number
    ) => {
        state.retryWarningCount = value;
    },
    [STORE_MUTATION.SetRetryInterval]: (state: StateOption, value: number) => {
        state.retryInterval = value;
    },
    [STORE_MUTATION.SetFocusedWindow]: (state: StateOption, value: boolean) => {
        state.focusedWindow = value;
    },
    [STORE_MUTATION.SetIsSignalRConnected]: (state: StateOption, value: boolean) => {
        state.isSignalRConnected = value;
    },
	[STORE_MUTATION.SetClientVersion]: (state: StateOption, value: string) => {
        state.clientVersion = value;
    },
	[STORE_MUTATION.SetMinimumClientVersion]: (state: StateOption, value: string) => {
        state.minimumClientVersion = value;
    },
    [STORE_MUTATION.SetShowTypingIndicator]: (
        state: StateOption,
        value: boolean
    ) => {
        state.showTypingIndicator = value;
        const shouldSkipDefaultScroll = state.shouldSkipDefaultScroll || state.isStreamingMessages;
        if (state.messages.length > 1 && !shouldSkipDefaultScroll) {
            __vueEvent.emit(EVENTS.ScrollChatToBottom);
        }

        // If the value is true, which means we are going to show the typing indicator,
        // then we need to hide any open processing messages.
        if (value) {
            state.showProcessingMessage = false;
            state.processingDisplayIcon = "";
            state.processingDisplayText = "";
        }
    },
    [STORE_MUTATION.SetShowProcessingMessage]: (state: StateOption, value: boolean) => {
        state.showProcessingMessage = value;
        const shouldSkipDefaultScroll = state.shouldSkipDefaultScroll || state.isStreamingMessages;
        if (state && state.messages && state.messages.length > 1 && !shouldSkipDefaultScroll) {
            __vueEvent.emit(EVENTS.ScrollChatToBottom);
        }
        
        // SD-11816: If the value is false, clear the processing timeout (with value of 1 minute) 
        // to prevent any unintended scroll to bottom behavior .
        if (typeof value === "boolean" && value === false) {
          __vueEvent.emit(EVENTS.ClearProcessingTimeout);
        }
    },
    [STORE_MUTATION.SetProcessingDisplayIcon]: (state: StateOption, value: string) => {
        state.processingDisplayIcon = value;
    },
    [STORE_MUTATION.SetProcessingDisplayText]: (state: StateOption, value: string) => {
        state.processingDisplayText = value;
    },
    [STORE_MUTATION.SetShowTrafficStatusBar]: (state: StateOption, value: boolean) => {
        state.showTrafficStatusBar = value;
    },
    [STORE_MUTATION.SetTrafficStatusText]: (state: StateOption, value: string) => {
        state.trafficStatusText = value;
    },

    [STORE_MUTATION.SetSatisfiURL]: (state: StateOption, value: string) => {
        state.satisfiURL = value;
    },

    // SD-3460: New mutations for the Admin Login and MFA
    [STORE_MUTATION.SetWebApiAddress]: (state: StateOption, value: string) => {
        state.webApiAddress = value;
    },
    [STORE_MUTATION.SetDashboardAddress]: (state: StateOption, value: string) => {
        state.dashboardAddress = value;
    },
    [STORE_MUTATION.SetAttemptNoofInvalidCode]: (state: StateOption, value: number) => {
        state.attemptNoofInvalidCode = value;
    },
    [STORE_MUTATION.SetAttemptNoofResendCode]: (state: StateOption, value: number) => {
        state.attemptNoofResendCode = value;
    },
    [STORE_MUTATION.SetMFAExpiration]: (state: StateOption, value: number) => {
        state.mfaExpiration = value;
    },
    [STORE_MUTATION.SetMFAEnableDateTime]: (state: StateOption, value: string) => {
        state.mfaEnableDateTime = value;
    },
    [STORE_MUTATION.SetAuthToken]: (state: StateOption, value: string) => {
        state.authToken = value;
    },
    [STORE_MUTATION.SetAuthTokenExpiration]: (state: StateOption, value: number) => {
        state.authTokenExpiration = value;
    },
    [STORE_MUTATION.SetIsMFAEnabled]: (state: StateOption, value: boolean) => {
        state.isMFAEnabled = value;
    },
    [STORE_MUTATION.SetRefreshTask]: (state: StateOption, value: any) => {
        state.refreshTask = value;
    },

    [STORE_MUTATION.SetAWSServerURL]: (state: StateOption, value: string) => {
        state.AWSServerURL = value;
    },

    [STORE_MUTATION.SetAWSThemeFilePath]: (state: StateOption, value: string) => {
        state.AWSThemeFilePath = value;
    },

    [STORE_MUTATION.SetAWSImageLogoPath]: (state: StateOption, value: string) => {
        state.AWSImageLogoPath = value;
    },

    [STORE_MUTATION.SetAWSPopupConfigPath]: (state: StateOption, value: string) => {
        state.AWSPopupConfigPath = value;
    },
    [STORE_MUTATION.SetHeaderImage]: (state: StateOption, value: string) => {
        state.headerImage = value;
    },
    [STORE_MUTATION.SetBackgroundImage]: (state: StateOption, value: string) => {
        state.backgroundImage = value;
    },
    [STORE_MUTATION.SetHeaderImageDestinationURL]: (state: StateOption, value: string) => {
        state.headerImageDestinationURL = value;
    },
    [STORE_MUTATION.SetHeaderImageDestTrackingURL]: (state: StateOption, value: string) => {
        state.headerImageDestTrackingURL = value;
    },
    [STORE_MUTATION.SetThumbsDownResponse]: (state: StateOption, value: string) => {
        state.thumbsDownResponse = value;
    },
    [STORE_MUTATION.SetThumbsupResponse]: (state: StateOption, value: string) => {
        state.thumbsUpResponse = value;
    },
    [STORE_MUTATION.RemoveAllButtons]: (state: StateOption, param: { msgIndex: number, structureIndex: number, compIndex: number }) => {
			try {
				// Get the last message index
				let msgIndex = state.messages.length - 1;
				if (msgIndex < 0) {
					return; // No messages to process
				}

				const lastMessage = state.messages[msgIndex];
				const structures = lastMessage && lastMessage.contents && lastMessage.contents.structures;

				// Exit if there are no structures to process
				if (!Array.isArray(structures) || structures.length === 0) return;

				if (state.messages[msgIndex].contents.structures.length > 0) {
					switch (state.messages[msgIndex].contents.structures[0].type) {
						case MESSAGE_STRUCTURE_TYPE.Time:
						case MESSAGE_STRUCTURE_TYPE.FetchMsg:
							msgIndex = --msgIndex;
					}

					// Validate adjusted message index
					if (msgIndex < 0) return;
					state.messages[msgIndex] = removeButtonsFromPayload(state.messages[msgIndex]);
				}
				//state.messages[msgIndex].contents.quickReplies = [];
			} catch (ex) {
				console.log("[mutations.ts] An error has occurred \n-> Inside STORE_MUTATION.RemoveAllButtons -> Error: ", ex);
			}
    },
    [STORE_MUTATION.SetTypingType]: (state: StateOption, value: number) => {
        state.typingType = value;
    },
    [STORE_MUTATION.SetIsUserHasAvatar]: (state: StateOption, value: boolean) => {
        state.isUserHasAvatar = value;
    },
    [STORE_MUTATION.SetIsBotHasAvatar]: (state: StateOption, value: boolean) => {
        state.isBotHasAvatar = value;
    },
    [STORE_MUTATION.SetLastFocusableElement]: (state: StateOption, value: HTMLElement) => {
        state.lastFocusableElement = value;
    },
    [STORE_MUTATION.SetConvId]: (state: StateOption, value: string) => {
        state.convId = value;
    },
    [STORE_MUTATION.SetPageId]: (state: StateOption, value: string) => {
        state.pageId = value;
    },
    [STORE_MUTATION.SetPopupId]: (state: StateOption, value: string) => {
        state.popupId = value;
    },
    [STORE_MUTATION.SetPageReferralUrl]: (state: StateOption, value: string) => {
        state.pageReferralUrl = value;
    },
    [STORE_MUTATION.SetParentSiteUrl]: (state: StateOption, value: string) => {
        state.parentSiteUrl = value;
    },
    [STORE_MUTATION.SetParentSiteReferralUrl]: (state: StateOption, value: string) => {
        state.parentSiteReferralUrl = value;
    },
    [STORE_MUTATION.SetSessionId]: (state: StateOption, value: string) => {
        state.sessionId = value;
    },
    [STORE_MUTATION.SetRequestResponseReceived]: (state: StateOption, value: boolean) => {
        state.requestResponseReceived = value;
    },
    [STORE_MUTATION.SetLastMessageId]: (state: StateOption, value: number) => {
        state.lastMessageId = Number(value);
    },
    [STORE_MUTATION.SetUserLat]: (state: StateOption, value: string) => {
        state.userLat = value;
    },
    [STORE_MUTATION.SetUserLng]: (state: StateOption, value: string) => {
        state.userLng = value;
    },
    [STORE_MUTATION.SetLocationBlocked]: (state: StateOption, value: boolean) => {
        state.locationBlocked = value;
    },
    [STORE_MUTATION.SetShouldShowBanner]: (
        state: StateOption,
        value: boolean
    ) => {
        state.shouldShowBanner = value;
    },
    [STORE_MUTATION.SetShowWelcomeBanner]: (state: StateOption, value: boolean) => {
        state.showWelcomeBanner = value;
    },
    [STORE_MUTATION.SetIsNewMessageProcessing]: (state: StateOption, value: boolean) => {
        state.isNewMessageProcessing = value;
    },
    [STORE_MUTATION.SetPiiSensitivity]: (state: StateOption, value: string) => {
        state.piiSensitivity = value;
    },
    [STORE_MUTATION.SetIOSInputFontFix]: (state: StateOption, value: boolean) => {
        state.iOSInputFontFix = value;
    },
    [STORE_MUTATION.SetPageStatusId]: (state: StateOption, value: number) => {
        state.pageStatusId  = value;
    },
    [STORE_MUTATION.SetBannerText]: (state: StateOption, value: string) => {
        state.bannerText = value
    },

    [STORE_MUTATION.AddGeneralTimeStamp]: (state: StateOption, payload) => {
        const message = {
            type: MESSAGE_TYPE.TimeStamp,
            id: payload.msg.id + MESSAGE_STRUCTURE_TYPE.Time,
						__vueKey: getUniqId(),
            contents: {
                structures: [
                    {
                        type: MESSAGE_STRUCTURE_TYPE.Time,
                        components: [
                            {
                                originalTime: payload.date, // retain the original Date object in our message structure
                                content: getTimeStamp(payload.date),
                                type: MESSAGE_COMPONENT_TYPE.Text
                            }
                        ]
                    }
                ]
            }
        };
        
        
        state.incomingScrollPosition = "default";
            
        state.messages.splice(state.messages.length - 1, 0, message);
        if (state.messages.length > 1 && !state.isStreamingMessages) {
            __vueEvent.emit(EVENTS.ScrollChatToBottom);
        }
    },
    [STORE_MUTATION.AddFetchMsgStamp]: (state: StateOption, content: string) => {
        state.messages.splice(0, 0, {
            type: MESSAGE_TYPE.TimeStamp,
            id: STORE_MUTATION.AddFetchMsgStamp,
            __vueKey: getUniqId(),
            contents: {
                structures: [
                    {
                        type: MESSAGE_STRUCTURE_TYPE.FetchMsg,
                        components: [
                            {
                                content: content,
                                type: MESSAGE_COMPONENT_TYPE.Text
                            }
                        ]
                    }
                ]
            }
        });
    },
    [STORE_MUTATION.RemoveStampMessage]: (state: StateOption) => {
        const index = state.messages.findIndex(
            qry => qry.id === STORE_MUTATION.AddFetchMsgStamp
        );
        state.messages.splice(index, 1);
    },
    [STORE_MUTATION.SetIsAppInAdaMode]: (state: StateOption, value: boolean) => {
        state.isAppInAdaMode = value;
    },
    [STORE_MUTATION.ClearScreen]: (state: StateOption) => {
        state.messages = [];
    },
    [STORE_MUTATION.RemoveMessage]: (state: StateOption, messageId: string) => {
        var index = state.messages.findIndex(qry => qry.id === messageId);
        if (index >= 0) {
            state.messages.splice(index, 1);
        }
    },
    [STORE_MUTATION.PrependMessages]: (state: StateOption, messages: IMessage[]) => {
        messages.forEach(function (message, i) {
            state.messages.splice(0, 0, message);
            __vueEvent.emit(EVENTS.PrependMessage, message);
        });
    },
    [STORE_MUTATION.PrependTimeStamp]: async (state: StateOption, payload) => {
        const message = {
            type: MESSAGE_TYPE.TimeStamp,
						__vueKey: getUniqId(),
            contents: {
                structures: [
                    {
                        type: MESSAGE_STRUCTURE_TYPE.Time,
                        components: [
                            {
                                originalTime: payload.date, // retain the original Date object in our message structure
                                content: getTimeStamp(payload.date),
                                type: MESSAGE_COMPONENT_TYPE.Text
                            }
                        ]
                    }
                ]
            }
        };
        state.messages.splice(payload.spliceIndex, 0, message);
        // __vueEvent.emit(EVENTS.PrependMessage, message);
    },
	[STORE_MUTATION.SetIsTilesOpenedInIframe]: (state: StateOption, value: boolean) => {
        state.isTilesOpenedInIframe = value;
    },
    [STORE_MUTATION.SetCFHeader]: (state: StateOption, value: string) => {
        state.cfHeader = value;
    },
    [STORE_MUTATION.SetShowAdminLoginModal]: (state: StateOption, value: boolean) => {
        state.showAdminLoginModal = value;
    },
    [STORE_MUTATION.SetAdminModalStep]: (state: StateOption, value: number) => {
        state.adminModalStep = value;
    },
    [STORE_MUTATION.SetShowTranscriptModal]: (state: StateOption, value: boolean) => {
		    state.showTranscriptModal = value;
	  },
    [STORE_MUTATION.SetIsAdminMode]: (state: StateOption, value: boolean) => {
        state.isAdminMode = value;
    },
    [STORE_MUTATION.SetEnableAdminMode]: (state: StateOption, value: boolean) => {
        state.enableAdminMode = value;
    },
    [STORE_MUTATION.SetShowModal]: (state: StateOption, value: IMessage) => {
        try {

            const msg = state.messages.find(message => message.id === value.id);
            if (msg != null && msg.contents && msg.contents.structures && msg.contents.structures.length > 0) {
                const structure = msg.contents.structures[0];

                // Get the value for showModal passed as IMessage
                let showModal;
                if (value && value.contents && value.contents.structures && value.contents.structures.length > 0) {
                    showModal = value.contents.structures[0].showModal;
                }

                structure.showModal = showModal;
            }

        } catch (ex) {
            console.log("[mutations.ts] An error has occurred \n-> Inside STORE_MUTATION.SetShowModal -> Error: ", ex);
        }
    },
    [STORE_MUTATION.SetIsTermsConsentEnabled]: (state: StateOption, value: boolean) => {
        state.isTermsConsentEnabled = value;
    },
    [STORE_MUTATION.SetIsFirstUserMessage]: (state: StateOption, value: boolean) => {
        state.isFirstUserMessage = value;
    },
    [STORE_MUTATION.SetIsTermsOfServiceAccepted]: (state: StateOption, value: boolean) => {
        state.isTermsOfServiceAccepted = value;
    },
    [STORE_MUTATION.SetTermsConsentPayload]: (state: StateOption, value: string) => {
        state.termsConsentPayload = value;
    },
    [STORE_MUTATION.SetTermsConsentExpiration]: (state: StateOption, value: string) => {
        state.termsConsentExpiration = value;
    },
    [STORE_MUTATION.SetShowConsentModal]: (state: StateOption, value: boolean) => {
        state.showConsentModal = value;
    },
    [STORE_MUTATION.SetConsentStatusOptions]: (state: StateOption, value: MessageOptions | null) => {
        state.consentStatusOptions = value;
    },
    [STORE_MUTATION.SetFormInput]: (state: StateOption, value: IFormInput) => {
        try {
            // Check if the formInputs array exists
            if (!state.formInputs) {
                state.formInputs = [];
            }

            // Check if the input already exists
            const existingInput = state.formInputs.find(item => item.fieldId === value.fieldId);

            if (existingInput) {
                // Update the existing input if found
                existingInput.fieldName = value.fieldName;
                existingInput.fieldValue = value.fieldValue;
            } else {
                // Add the input to the array if it doesn't exist
                state.formInputs.push(value);
            }

        } catch (ex) {
            console.log("[mutations.ts] An error has occurred \n-> Inside STORE_MUTATION.SetFormInput -> Error: ", ex);
        }
    },
    [STORE_MUTATION.ClearFormInputs]: (state: StateOption) => {
        state.formInputs = [];
    },
    [STORE_MUTATION.SetIsMaintainStateMessages]: (state: StateOption, value: boolean) => {
        state.isMaintainStateMessages = value;
    },
    [STORE_MUTATION.SetEnableMessageNavigation]: (state: StateOption, value: boolean) => {
        state.enableMessageNavigation = value;
    },
    [STORE_MUTATION.SetFormItemChange]: (
      state: StateOption,
      value: { messageId: string; name: string; value: any }
    ) => {
      try {
        const msg = state.messages.find(message => message.id === value.messageId);
        if (
					msg != null &&
					msg.contents &&
					msg.contents.structures &&
					Array.isArray(msg.contents.structures) &&
					msg.contents.structures.length > 0 &&
					msg.contents.structures[0].type === MESSAGE_STRUCTURE_TYPE.Modal
				) {
					// This is the structure that contains the modal component
					const structure = msg.contents.structures[0];

					if (
						structure.components &&
						Array.isArray(structure.components) &&
						structure.components.length > 0 &&
						structure.components[0].type === MESSAGE_COMPONENT_TYPE.Form
					) {
						// This is the form component
						const formComponent = structure.components[0];

						if (
							formComponent.formItems &&
							Array.isArray(formComponent.formItems) &&
							formComponent.formItems.length > 0
						) {
							// This is the form items array
							const formItems = formComponent.formItems;

							// Find the form item that matches the name
							const formItem = formItems.find((item) => item.name === value.name);

							if (formItem) {
								// Update the form item value
								formItem.value = value.value;
							}
						}
					}
				}
      } catch (ex) {
        console.log("[mutations.ts] An error has occurred \n-> Inside SetFormItemChange -> Error: ", ex);
      }
    },
    [STORE_MUTATION.SetFormButtonOptions]: (state: StateOption, value: { messageId: string }) => {
      try {
        // Find the message in the state that matches the messageId
        const msg = state.messages.find((message) => message.id === value.messageId);

        // Validate the message structure
        if (
          msg != null &&
          msg.contents &&
          msg.contents.structures &&
          Array.isArray(msg.contents.structures) &&
          msg.contents.structures.length > 0 &&
          msg.contents.structures[0].type === MESSAGE_STRUCTURE_TYPE.Modal
        ) {
          // This is the structure that contains the modal component
          const structure = msg.contents.structures[0];

          if (
            structure.components &&
            Array.isArray(structure.components) &&
            structure.components.length > 0 &&
            structure.components[0].type === MESSAGE_COMPONENT_TYPE.Form
          ) {
            // This is the form component
            const formComponent = structure.components[0];

            // Check if the form has a footer array
            if (
              formComponent.formFooter &&
              Array.isArray(formComponent.formFooter) &&
              formComponent.formFooter.length > 0
            ) {
              // This is the form footer array
              const formFooter = formComponent.formFooter;

              // Check if we have items with type button in the form footer
              // and set the messageId for each button
              for (let item of formFooter) {
                if (item.type === MESSAGE_COMPONENT_TYPE.Button) {
                  // Check if the clickAction property exists in the item and if it is an object
                  if (!item.clickAction || typeof item.clickAction !== "object") {
                    item.clickAction = {
                      settings: {},
                    };
                  }

                  // Ensure 'clickAction' and 'settings' objects are initialized
                  if (!item.clickAction.settings) {
                    item.clickAction.settings = {};
                  }

                  // Add the messageId to the settings object
                  item.clickAction.settings.messageId = value.messageId;
                  item.clickAction.settings.sendFormEntries = true;
                }
              }
            }
          }
        }
      } catch (ex) {
        console.log("[mutations.ts] An error has occurred \n-> Inside SetFormButtonOptions -> Error: ", ex);
      }
    },
    [STORE_MUTATION.SetUpdatePageConfig]: (
      state: StateOption,
      { payload, maintainState }: { payload: Partial<IPageConfig>, maintainState?: boolean }
    ) => {
      try {
        // Skip if the payload is not an object or is empty
        if (!payload || typeof payload !== "object" || Object.keys(payload).length === 0) {
          return;
        }

        /**
         * Updates the time format of the last 10 messages in the chat.
         *
         * This function slices the last 10 messages from the state and updates their time format.
         * It specifically looks for messages of type `MESSAGE_TYPE.TimeStamp` and updates the
         * time format of components of type `MESSAGE_COMPONENT_TYPE.Text` that have an `originalTime` property.
         *
         * @remarks
         * This function was implemented as per the discussion with Randy to optimize performance by
         * only updating the last 10 messages.
         *
         * @returns {void} This function does not return anything.
         */
        const updateMessagesTimeFormat = () => {
					// Extract messages with type === 2
					const filteredMessages = state.messages
						? state.messages.filter((message) => message.type === MESSAGE_TYPE.TimeStamp)
						: [];

					// Update only last 10 time stamps in the chat
					const messagesToUpdate = filteredMessages.slice(-10);
					if (!messagesToUpdate || messagesToUpdate.length === 0) return; // Guard clause

					// Loop through the last 10 messages and update the time format
					messagesToUpdate.forEach((message) => {
						if (message.type === MESSAGE_TYPE.TimeStamp) {
							message.contents &&
								message.contents.structures.forEach((structure) => {
									if (structure.type === MESSAGE_STRUCTURE_TYPE.Time) {
										structure.components &&
											structure.components.forEach((component) => {
												if (component.type === MESSAGE_COMPONENT_TYPE.Text && component.originalTime) {
													component.content = getTimeStamp(component.originalTime);
												}
											});
									}
								});
						}
					});
				};

        /**
         * Removes the chat state from local storage based on conversation and page IDs.
         * This function attempts to clean up stored chat configurations when they're no longer needed.
         *
         * The function performs the following steps:
         * 1. Retrieves the page ID from the current state
         * 2. Constructs a unique conversation ID by combining the conversation ID with page ID
         * 3. Checks if the conversation exists in storage
         * 4. If found, removes the associated chat configuration using the storage key pattern 'swc_pcfg_[convId]'
         */
        const removeStateFromLocalStorage = () => {
					try {
						// Check if the previous conversation ID exists in local storage
						const pageId = state.pageId || "";
						if (!pageId) return; // skip if pageId is not available

						const uniqueConvId = `${_convId}${pageId}`;
						const convId = StorageHelper.get(uniqueConvId);
						if (!convId) return; // Exit early if convId is not found

						const storageKey = `swc_pcfg_${convId}`;
						if (StorageHelper.get(storageKey)) {
							StorageHelper.remove(storageKey);
						}
					} catch (ex3) {
						//console.log("[mutations.ts] An error has occurred \n-> removeStateFromLocalStorage -> Error: ", ex3);
					}
				};

        /**
         * Saves a partial page configuration to local storage.
         * The storage only occurs if maintainState is enabled and a valid conversation ID exists.
         *
         * @param value - Partial page configuration to be stored
         * @remarks
         * The storage key is created using the pattern `swc_pcfg_${convId}`
         * The value is stringified before storage.
         */
        const saveStateInLocalStorage = (value: Partial<IPageConfig>) => {
          try {
            // Use either the maintainState value or the one passed in the payload
            let localMaintainState = maintainState || state.maintainState;
            // Skip if maintainState is not enabled
            if (!localMaintainState) {
              removeStateFromLocalStorage();
              return;
            }

            // Create the storage key and value
            const convId = state.convId;
            if (!convId) return; // skip if convId is not available
            if (!value || typeof value !== 'object') return; // skip if value is not an object
            const storageKey = `swc_pcfg_${convId}`;
            const storageValue = JSON.stringify(value);

            // Save the value in local storage
            StorageHelper.set(storageKey, storageValue);
          } catch (ex2) {
            //console.log("[mutations.ts] An error has occurred \n-> saveStateInLocalStorage -> Error: ", ex2);
          }
        };

        let isUpdated = false; // Track if any property was updated

				// Small guards for clarity and reuse
        const isNullOrEmptyString = (v: unknown): v is string => typeof v === "string" && Util.isNullOrEmpty(v);
        const isMissing = (v: unknown) => v == null || isNullOrEmptyString(v);

				// Type-guard for formLabels property in IPageConfig
        const isFormLabels = (v: unknown): v is IPageConfig["formLabels"] => {
        	return typeof v === "object" && v !== null && !Array.isArray(v);
        };

        // Iterate over each key in the payload object
        const keys = Object.keys(payload) as (keyof IPageConfig)[];
        keys.forEach((key) => {
        	// Get the value of the current key from the payload, ensuring type safety with keyof IPageConfig
        	const value = payload[key];

        	// Skip null/undefined, and skip empty strings
        	if (isMissing(value)) return;

        	const lowerCaseKey = String(key).toLowerCase();
        	const targetKey = "messagetimeformat";

        	if (key === "formLabels") {
        		if (isFormLabels(value)) {
        			// safe assignment using the type-guard
        			state.pageConfig.formLabels = value;
        			isUpdated = true;
        		}
        	} else {
        		// Remaining keys are expected to be string-typed in IPageConfig
        		if (typeof value === "string") {
        			// Update the corresponding property in the Vuex state with the value from the payload
        			state.pageConfig[key] = value;
        			isUpdated = true; // Mark as updated

        			// Check if the key is 'messageTimeFormat' and update the other state property
        			if (lowerCaseKey === targetKey) {
        				updateMessagesTimeFormat();
        			}
        		}
        	}
        });

        // Emit event if at least one property was updated
        if (isUpdated) {
          __vueEvent.emit(EVENTS.PageConfigUpdated, true);
          saveStateInLocalStorage(payload);
        }
      } catch (ex) {
        console.log("[mutations.ts] An error has occurred \n-> Inside SetUpdatePageConfig -> Error: ", ex);
      }
    },
    /**
     * SD-6819: Sets the flag to indicate if the messages have been restored, when maintain state is enabled.
     */
    [STORE_MUTATION.SetIsMessagesRestored]: (state: StateOption, value: boolean) => {
      state.isMessagesRestored = value;
    },
    /* SD-5915: Part of carousel feature implementation to show the carousel detail in popup instead chat container and also used to toggle the view */
    [STORE_MUTATION.UpdateCarouselModalDetail]: (state: StateOption, payload: PropsComponent | null) => {
      state.carouselModalDetail = payload;
    },
    /* SD-5915: Part of carousel feature implementation to show the carousel and list view inside the bottom sheet instead chat container and also used to toggle the view */
    [STORE_MUTATION.UpdateCarouselModalList]: (state: StateOption, payload: PropsLayoutCarousel | null) => {
      state.carouselModalList = payload;
    },
    [STORE_MUTATION.SetClientSiteLanguage]: (state: StateOption, value: string | null) => {
      state.clientSiteLanguage = value;
    },
    [STORE_MUTATION.SetBaseInlineActionUrl]: (state: StateOption, value: string) => {
      state.baseInlineActionUrl = value;
    },
	[STORE_MUTATION.SetTaglineUrl]: (state: StateOption, value: string) => {
		state.taglineUrl = value;
	},
	[STORE_MUTATION.SetScreenReaderAnnouncement]: (state: StateOption, value?: string) => {
		state.screenReaderAnnouncement = value;
    },
    // [STORE_MUTATION.UpdateIsStreamingMessages]: (state: StateOption, payload: boolean | null) => {
	// 	state.isStreamingMessages = payload;
	// },
    [STORE_MUTATION.SetLastFocusedElement]: (state: StateOption, value: HTMLElement | null) => {
    state.lastFocusedElement = value;
    },
  [STORE_MUTATION.SetSuppressNextScroll]: (state: StateOption, value: boolean) => {
    state.suppressNextScroll = value;
  },
    
    [STORE_MUTATION.UpdateIsStreamingMessages]: (state: StateOption, payload: boolean | null) => {
		state.isStreamingMessages = payload;
	},
  [STORE_MUTATION.SetShouldSkipDefaultScroll]: (state: StateOption, payload: boolean) => {
		state.shouldSkipDefaultScroll = payload;
	},
  [STORE_MUTATION.SetSenderDisplayName]: (state: StateOption, value: string) => {
		state.senderDisplayName = value;
  },
  [STORE_MUTATION.SetSenderLiveDisplayName]: (state: StateOption, value: string) => {
		state.senderLiveDisplayName = value;
  },
  [STORE_MUTATION.SetAIAgentAvatarUrl]: (state: StateOption, value: string) => {
		state.aiAgentAvatarUrl = value;
  },
  [STORE_MUTATION.SetLiveAgentAvatarUrl]: (state: StateOption, value: string) => {
		state.liveAgentAvatarUrl = value;
  },
    [STORE_MUTATION.SkipWelcomeMessageOnURLInput]: (state: StateOption, value: boolean) => {
        state.skipWelcomeMessageOnURLInput = value;
    },
  [STORE_MUTATION.SetIsStreamingPages]: (state: StateOption, value: boolean) => {
		state.isStreamingPages = value;
  },
  [STORE_MUTATION.SetLastScrollPosition]: (state: StateOption, value: string) => {
		state.lastFocusableElement = value;
  },
  [STORE_MUTATION.SetViewPointHeight]: (state: StateOption, value: number) => {
		state.viewPointHeight = value;
  },
  [STORE_MUTATION.SetIncomingScrollPosition]: (state: StateOption, value: string) => {
		state.incomingScrollPosition = value;
  },
  [STORE_MUTATION.SetInLineClickedURL]: (state: StateOption, value: string) => {
		state.inLineClickedURL = value;
  },
  [STORE_MUTATION.SetCarouselButtonClicked]: (state: StateOption, value: boolean) => {
		state.carouselButtonClicked = value;
  },
  // Message feedback mutations
  ...feedbackMutations,
};

//#endregion
